import { api } from "./configs/axiosConfigs"

export const ParameterAPI = {

  index: async function (cancel = false) {
    const response = await api.request({
      url: "/parameters",
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  show: async function (parameter, cancel = false) {
    const response = await api.request({
      url: "/parameters/" + parameter,
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  update: async function (parameter, data, cancel = false) {
    const response = await api.request({
      url: "/parameters/" + parameter,
      method: "PUT",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },
}
